import { faFrown, faPaperPlane } from '@fortawesome/pro-solid-svg-icons';

/**
 * # requestPasswordReset
 * Controller of the gateApp. Responsible for /request-password-reset route
 */
angular.module('gateApp').component('requestPasswordReset', {
  template: require('./request-password-reset.html').default,
  controller: function ($routeParams: ng.route.IRouteParamsService, user) {
    const $ctrl = this;

    $ctrl.faFrown = faFrown;
    $ctrl.faPaperPlane = faPaperPlane;

    $ctrl.username = $routeParams.username;

    $ctrl.reset = (username) => {
      $ctrl.error = undefined;

      user.requestPasswordReset(username).then(
        (message) => {
          $ctrl.message = message;
        },
        (errorMessage) => {
          $ctrl.error = errorMessage;
          $ctrl.message = undefined;
        },
      );
    };
  },
});
